import { render, staticRenderFns } from "./components.parent-reply.vue?vue&type=template&id=4348f6ac"
import script from "./components.parent-reply.vue?vue&type=script&lang=js"
export * from "./components.parent-reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports